import React, {Component} from 'react';
import {fetchCustomerInquiries} from '../../../actions/customerInquiry.actions';
import {connect} from 'react-redux';
import InquiryTable from './InquiryTable';
import {Link} from 'react-router-dom';
import {Button, ButtonGroup} from '../../Common/PageComponents';

const stateToProps = state => {
  return {
    answeredInquiries: state.customerInquiries.answeredInquiries,
    notAnsweredInquiries: state.customerInquiries.notAnsweredInquiries,
  };
};

class CustomerInquiryHistory extends Component {
  componentDidMount() {
    this.props.dispatch(fetchCustomerInquiries());
  }

  render() {
    return (
      <div>
        <InquiryTable inquiries={this.props.answeredInquiries} title="답변 중인 질문" />
        <InquiryTable inquiries={this.props.notAnsweredInquiries} title="답변 된 질문" />
        <ButtonGroup>
          <Link to="/customer/inquiries/submission">
            <Button>상담하기</Button>
          </Link>
        </ButtonGroup>
      </div>
    );
  }
}

export default connect(stateToProps)(CustomerInquiryHistory);
